import { auth } from '../config/firebase';

export class UserManagementService {
  static async getAuthToken() {
    const user = auth.currentUser;
    if (!user) {
      throw new Error('Utilisateur non authentifié');
    }
    return await user.getIdToken();
  }

  static async deleteUser(userId) {
    try {
      const token = await this.getAuthToken();
      
      const response = await fetch('https://us-central1-freefire-9b31f.cloudfunctions.net/deleteUser', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ userId })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Erreur lors de la suppression');
      }

      return await response.json();
    } catch (error) {
      console.error('Erreur lors de la suppression de l\'utilisateur:', error);
      throw error;
    }
  }

  static async syncUsers() {
    try {
      const token = await this.getAuthToken();
      
      const response = await fetch('https://us-central1-freefire-9b31f.cloudfunctions.net/syncUsers', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Erreur lors de la synchronisation');
      }

      return await response.json();
    } catch (error) {
      console.error('Erreur lors de la synchronisation des utilisateurs:', error);
      throw error;
    }
  }

  static async getActiveUsers() {
    try {
      const token = await this.getAuthToken();
      
      const response = await fetch('https://us-central1-freefire-9b31f.cloudfunctions.net/getActiveUsers', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Erreur lors de la récupération');
      }

      const result = await response.json();
      return result.users;
    } catch (error) {
      console.error('Erreur lors de la récupération des utilisateurs actifs:', error);
      throw error;
    }
  }
}